import { useState } from "react";
import { TableCredContent } from "../styled";
import {
  ColumnTitle,
  TableBody,
  TableColumn,
  TableContainer,
  TableHead,
  TableHeader,
  TableRowOrdemService,
  TableTitle,
} from "../../../../../../../../CSSGlobal";
import listTables from "../tableTitles.json";
import { Alert, Button, Tooltip } from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { CiTrash } from "react-icons/ci";
import { GoKey } from "react-icons/go";
import { limitarTexto } from "../../../../../../../../function/utilis/function";

export function TabelaCredenciais({
  setIsModalAddVisible,
  isCredenciaisAdicionais,
  paginatedData,
  handleModalEditar,
  handleModalRemover,
}) {
  const [titleTable, setTitleTable] = useState(listTables);


  return (
    <>
      <TableCredContent>
        <TableHeader>
          <TableHead>
            {titleTable[0].titles.map((item, index) => {
              return (
                <ColumnTitle key={index} id={index}>
                  <TableTitle>
                    {item.title === "Adicionar" ? (
                      <>
                      <Tooltip title="Adicionar Credencial">
                        <div
                          onClick={() => setIsModalAddVisible(true)}
                          className="hover-padrao position-btn btn-model style-model"
                        >
                          <PlusOutlined />
                        </div>
                        <div className="key">
                          <GoKey />
                        </div>
                        </Tooltip>
                      </>
                    ) : (
                      <span className="span-title">{item.title}</span>
                    )}
                  </TableTitle>
                </ColumnTitle>
              );
            })}
          </TableHead>
        </TableHeader>
        <TableContainer>
          <TableBody>
            {!isCredenciaisAdicionais ||
            Object.keys(isCredenciaisAdicionais).length === 0 ||
            Object.values(isCredenciaisAdicionais).every(
              (arr) => Array.isArray(arr) && arr.length === 0
            ) ? (
              <Alert
                message="Nenhuma credencial adicional disponível."
                type="info"
                showIcon
              />
            ) : (
              paginatedData.map((credencial, index) => (
                <>
                  <TableRowOrdemService key={index}>
                    <TableColumn>
                      <span>{credencial.tipo?.id}</span>
                    </TableColumn>
                    <TableColumn>
                      <Tooltip title={credencial.site}>
                        <span>
                          <a
                            href={credencial.site}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {limitarTexto(credencial.site)}
                          </a>
                        </span>
                      </Tooltip>
                    </TableColumn>
                    <TableColumn>
                      <span>{credencial.codigo}</span>
                    </TableColumn>
                    <TableColumn>
                      <span>{credencial.senha}</span>
                    </TableColumn>
                    <TableColumn>
                      <Tooltip title="Editar">
                        <div
                          className="btn-model style-model hover-padrao"
                          style={{ margin: 3 }}
                          onClick={() => handleModalEditar(credencial.id)}
                        >
                          <EditOutlined />
                        </div>
                      </Tooltip>

                      <Tooltip title="Remover">
                        <div
                          className="btn-model style-model hover-remove"
                          style={{ margin: 3, fontSize: 21 }}
                          onClick={() => handleModalRemover(credencial.id)}
                        >
                          <CiTrash />
                        </div>
                      </Tooltip>
                    </TableColumn>
                  </TableRowOrdemService>
                </>
              ))
            )}
          </TableBody>
        </TableContainer>
      </TableCredContent>
    </>
  );
}

export default TabelaCredenciais;
